import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import {ApplicationSettingService} from 'application/application-setting/services';
import {resolveColumns} from 'application/facility/util/resolveColumns';
import { action, observable } from 'mobx';
import { ModalParams } from 'core/models';

@applicationContext
class ApplicationSettingListViewStore extends BaseListViewStore {
	@observable accessor counter = 0;
    constructor(rootStore) {
        const applicationSettingService = new ApplicationSettingService(rootStore.application.baasic.apiClient);
        let routes = {};

        super(rootStore, {
            name: 'application-setting',
            autoInit: true,
            routes: routes,
            actions: () => {
                return {
                    find: async (params) => {
                        if(this.counter === 0)
						{
							params.orderBy = "category";
							params.orderDirection = "asc";
							this.counter++;
						}
                        const response = await applicationSettingService.find({
                            ...params,
                            embed:'ApplicationSettingCategory'
                        });

                        response.data.item = response.data.item.map(i => {
                            return {
                                ...i,
                                category: i.applicationSettingCategory && i.applicationSettingCategory.name
                            };
                        });

                        return response.data;
                    },
                    delete: async (item) => {
                        await applicationSettingService.delete(item);
                    }
                }
            },
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'category',
                    title: 'APPLICATION_SETTING.LIST.COLUMNS.CATEGORY',
                },
                {
                    key: 'name',
                    title: 'APPLICATION_SETTING.LIST.COLUMNS.NAME'
                },
                {
                    key: 'value',
                    title: 'APPLICATION_SETTING.LIST.COLUMNS.VALUE',
                    sortable: false
                },
                {
                    key: 'type',
                    title: 'APPLICATION_SETTING.LIST.COLUMNS.TYPE',
                    sortable: false
                },               
            ]),
            actions: {
                onEdit: (item) => this.openEditModal(item)
            }
        }));

        this.editModal = new ModalParams({
            onClose: () => {
                this.queryUtility.fetch();   
            }
        });
    } 

    @action.bound
    openEditModal(item) {
        const applicationSettingId = item.id;
        this.editModal.open({
            id: applicationSettingId
        });
    }
}

export default ApplicationSettingListViewStore;
